import {
  Button,
  Card,
  CardContent,
  Col,
  List,
  ListInput,
  Row,
} from "framework7-react";
import React, { useEffect } from "react";
import { API_URL, POST_FILTER } from "src/utils/constants";
import { api } from "src/utils/utils";
import $ from "jquery";

interface ICardOrder {
  orderData: any;
  self: any;
}

const CardOrder: React.FC<ICardOrder> = ({ orderData, self }) => {
  const order = orderData;
  const getStore = (userId: any) => {
    return self.state.stores.find(
      (store: { user_id: any }) => store.user_id === userId
    ).name;
  };

  const saveOrder = async (orderId: number) => {
    if (self.$$) {
      const dialog = self.$f7?.dialog.preloader("Actualizando Orden");
      const orderUpdated = {
        id: orderId,
        remission: self.$$(".order-" + orderId + " .remission input").val(),
        invoice: self.$$(".order-" + orderId + " .invoice input").val(),
        is_invoice: self.$$(".order-" + orderId + " .is_invoice select").val(),
        data_status: self
          .$$(".order-" + orderId + " .data_status select")
          .val(),
        estatus: self.$$(".order-" + orderId + " .estatus select").val(),
      };

      const filter = { table: "ordersMA" };
      const postOrder = await api.post<any>(
        API_URL + POST_FILTER + encodeURIComponent(JSON.stringify(filter)),
        orderUpdated
      );

      console.log(postOrder);
      dialog?.close();
      self.$f7?.toast
        .create({
          text: "Orden " + postOrder.id + " actualizada con éxito ✅",
          position: "bottom",
          closeTimeout: 4500,
        })
        .open();
    }
  };

  useEffect(() => {
    // console.log(order);

    $(".order-" + order.id + " .remission input").val(order.remission);
    $(".order-" + order.id + " .invoice input").val(order.invoice);

    $(".order-" + order.id + " .estatus select").val(order.estatus);
    $(".order-" + order.id + " .data_status select").val(order.data_status);
    $(".order-" + order.id + " .is_invoice select").val(order.is_invoice);
  }, [orderData]);

  const statusShipping = (status: string) => {
    if (status === "ready_to_ship") {
      return "LISTO PARA ENVIAR";
    }
    return status;
  };
  const logisticType = (status: string) => {
    if (status === "fulfillment") {
      return "ENVIO FULL";
    } else {
      return status;
    }
  };

  return (
    <Row key="0" resizable={false} className="dashboard">
      <Col>
        <Card outline={true}>
          <CardContent>
            <div className={"order order-" + order.id}>
              <div className="info">
                {/* <div className="id">{order.id}</div> */}
                <div className="infoML">
                  <div className="infoItem">
                    <div className="idML">
                      <h2>
                        <strong>Pack ID: {order.pack_id}</strong> <br />
                        <strong>IDML: {order.idML}</strong> <br />
                      </h2>
                      <strong className="storeName">
                        🛍 Tienda: {getStore(order.user_id)}
                      </strong>{" "}
                      <br />
                      <br />
                      🕒{" "}
                      {new Date(order.created_at).toLocaleString("es-ES", {
                        weekday: "long",
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                        hour: "numeric",
                        minute: "numeric",
                        hour12: true,
                      })}
                    </div>
                    <div className="shipment">
                      <strong>
                        ➡️ {statusShipping(order.status_shipping)}
                      </strong>{" "}
                      <br />
                      📦 Tipo de envío:
                      <strong> {logisticType(order.logistic_type)}</strong>
                    </div>
                    <div className="description">
                      <strong>{order.description}</strong>
                    </div>
                  </div>
                  <div className="infoPrice">
                    <div className="sku">
                      SKU: <strong>{order.sku}</strong>
                    </div>
                    <div className="prices">
                      <div className="rPrice">
                        <div>PRECIO</div>
                        <div>$ {order.unit_price}</div>
                      </div>
                      <div className="rPrice">
                        <div>CANT.</div>
                        <div>{order.quantity}</div>
                      </div>
                      <div className="rPrice">
                        <div>TOTAL</div>
                        <div>${order.full_unit_price}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="controls">
                <div className="inputs">
                  <List>
                    <ListInput
                      outline
                      label="Remisión"
                      floatingLabel
                      type="text"
                      className="remission"
                      placeholder="Ingresar Remisión"
                    />

                    <ListInput
                      outline
                      label="Factura"
                      floatingLabel
                      type="text"
                      className="invoice"
                      placeholder="Ingresar Factura"
                    />
                  </List>
                </div>
                <div className="selects">
                  <List className="selects">
                    <ListInput
                      label="Estatus"
                      type="select"
                      className="estatus"
                      placeholder="Please choose..."
                    >
                      <option value="">--</option>
                      <option value="Abierto">⚪️ Abierto</option>
                      <option value="Completado">🟢 Completado</option>
                      <option value="Cancelado">🔴 Cancelado</option>
                    </ListInput>

                    <ListInput
                      label="¿Requiere factura?"
                      type="select"
                      className="is_invoice"
                      placeholder="Please choose..."
                    >
                      <option value="">--</option>
                      <option value="Nose">⚪️ Nose</option>
                      <option value="SI">🟢 Si</option>
                      <option value="NO">🔴 No</option>
                    </ListInput>

                    <ListInput
                      label="Datos"
                      type="select"
                      className="data_status"
                      placeholder="Please choose..."
                    >
                      <option value="">--</option>
                      <option value="N/A">⚪️ N/A</option>
                      <option value="SI">🟢 Si</option>
                      <option value="NO">🔴 Pendientes</option>
                    </ListInput>
                  </List>
                </div>
              </div>
            </div>
            <Row>
              <Col>
                {/* <Button
                  fill
                  color="blue"
                  raised
                  className="buttonSave"
                  onClick={() => {
                    self.openChat(order);
                  }}
                >
                  Chat
                </Button> */}
              </Col>

              <Col>
                <Button
                  fill
                  color="green"
                  raised
                  className="buttonSave"
                  onClick={() => {
                    saveOrder(order.id);
                  }}
                >
                  Guardar
                </Button>
              </Col>
            </Row>
            <br />
          </CardContent>
        </Card>
      </Col>
    </Row>
  );
};

export default CardOrder;



// WEBPACK FOOTER //
// ./src/components/prefabs/CardOrder.tsx